import React, { useState, useEffect, useRef } from "react";
import PresentationInfoPage from "../components/presentation-info-page";
import PresentationWelcomePage1 from "../components/presentation-welcome-page";
import PresentationTax1 from "../components/presentation-tax";
import PresentationCurrentPlan from "../components/presentation-current-plan";
import PresentationAssumptions from "../components/presentation-assumptions";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";
import PresentationFuture from "../components/presentation-future";
import PresentationResults from "../components/presentation-results";
import PresentationLayout2 from "../components/presentation-layout2";
import { saveFuturePlanRoadmap } from "../shared/api";
import { Grid } from "@mui/material";
import ReactDOMServer from 'react-dom/server'

const PAGE_INTRO = 0;
const PAGE_WELCOME_1 = 1;
const PAGE_TAX_1 = 2;
const THREE_CHARTS = 3;
const CURRENT_PLAN = 4;
const PLAN_ASSUMPTIONS = 5;
const PLAN_FUTURE = 6;

const Presentation = () => {
  const [cookies, setCookie] = useCookies(["loginToken"]);
  const [presentationPage, setPresentationPage] = useState(0);
  const { clientId } = useParams();

/*  useEffect(() => {
    saveFuturePlanRoadmap(clientId, cookies["loginToken"])
  }, []);*/

  const nextPage = () => {
    setPresentationPage((v) => v + 1);
  };

  const prevPage = () => {
    setPresentationPage((v) => v - 1);
  };

  const getPage = () => {

    switch (presentationPage) {
      case PAGE_INTRO:
        return <PresentationInfoPage clientId={clientId} token={cookies["loginToken"]} next={nextPage} prev={prevPage} />;
      case PAGE_WELCOME_1:
        return <PresentationWelcomePage1 next={nextPage} prev={prevPage} />;
      case PAGE_TAX_1:
        return <PresentationTax1 next={nextPage} prev={prevPage} />;
      case THREE_CHARTS:
        return <PresentationResults next={nextPage} prev={prevPage} />
      case CURRENT_PLAN:
        return <PresentationCurrentPlan />;
      case PLAN_ASSUMPTIONS:
        return <PresentationAssumptions />;
      case PLAN_FUTURE:
        return <PresentationFuture />;
    }
  };

  return (
    <PresentationLayout2>
      {""}
      <Grid>
        {getPage()}
      </Grid>

    </PresentationLayout2>
  );
};

export default Presentation;
